const androidRegex =
  'android.*mobile|webos|iphone|ipod|blackberry|iemobile|opera mini|mobile';
const iosRegex = 'iPad|iPhone|iPod|iPadOS|iPhoneOS|macintosh';
const mobileRegex = `${androidRegex}|${iosRegex}/i`;

export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as unknown as { opera?: string }).opera || '';

  const width = window.innerWidth;
  const hasTouchSupport =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if (
    width <= 480 &&
    (hasTouchSupport || new RegExp(mobileRegex, 'i').test(userAgent))
  ) {
    return true;
  }

  return false;
};

export const isIOSDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as unknown as { opera?: string }).opera || '';

  return new RegExp(iosRegex, 'i').test(userAgent) && !(window as unknown as { MSStream?: unknown }).MSStream;
};

export const isAndroidDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as unknown as { opera?: string }).opera || '';

  return new RegExp(androidRegex, 'i').test(userAgent);
};

export default {
  isMobileDevice,
  isIOSDevice,
  isAndroidDevice
};
